export default function characterTypeValidation(value, type, fieldName = 'Field') {
    if (type === 'ALPHANUMERIC') {
        return ''
    }
    const characterPatterns = {
        NUMERIC: {
            regex: /^-?\d+(\.\d+)?$/,
            description: 'numbers only'
        },
        ALPHA: {
            regex: /^[a-zA-Z\s.,]+$/,
            description: 'letters only'
        },
    };

    const expectedPattern = characterPatterns[type];
    if (!expectedPattern.regex.test(value)) {
        return `${fieldName} must contain ${expectedPattern.description}.`;
    }

    return '';
}
